// EDITED 2026-06-03 - Force mobile (drawer) mode below 815px.
// Horizon's setHeaderMenuStyle() runs on resize/load and may set data-menu-style='menu'
// at 750–814px. The MutationObserver corrects it back to 'drawer' in that range.
(function () {
  const BREAKPOINT = 815;

  // The inline desktop search and Horizon's built-in search modal are both in
  // the DOM. Horizon gives each instance the same result IDs, so the inline
  // input's aria-controls/aria-owns relationships become ambiguous. Namespace
  // the inline instance and reapply the IDs after predictive-search morphs its
  // result markup.
  function namespaceInlineSearch(component, index) {
    const suffix = index === 0 ? '' : `-${index + 1}`;
    const resultsId = `civicsupply-predictive-search-results${suffix}`;
    const productsId = `civicsupply-predictive-search-products${suffix}`;
    const input = component.querySelector('[ref="searchInput"]');
    const resultsContainer = component.querySelector('[ref="predictiveSearchResults"]');
    const results = component.querySelector('.predictive-search-dropdown[role="listbox"]');

    if (!input || !results) return;

    // The ref belongs to Horizon's content wrapper; aria-controls must point
    // to the nested listbox, not that wrapper.
    if (
      resultsContainer &&
      resultsContainer !== results &&
      resultsContainer.id.indexOf('civicsupply-predictive-search-results') === 0
    ) {
      resultsContainer.removeAttribute('id');
    }
    if (results.id !== resultsId) results.id = resultsId;
    if (input.getAttribute('aria-controls') !== resultsId) input.setAttribute('aria-controls', resultsId);
    if (input.getAttribute('aria-owns') !== resultsId) input.setAttribute('aria-owns', resultsId);

    results.querySelectorAll('.predictive-search-results__products').forEach((products, productIndex) => {
      const id = productIndex === 0 ? productsId : `${productsId}-${productIndex + 1}`;
      if (products.id !== id) products.id = id;
    });
  }

  function initInlineSearchIds() {
    document.querySelectorAll('.civicsupply-search-bar-component').forEach((component, index) => {
      const applyIds = () => namespaceInlineSearch(component, index);
      applyIds();

      new MutationObserver(applyIds).observe(component, {
        attributes: true,
        attributeFilter: ['id', 'aria-controls', 'aria-owns'],
        childList: true,
        subtree: true,
      });
    });
  }

  function enforce(header) {
    if (window.innerWidth < BREAKPOINT && header.dataset.menuStyle !== 'drawer') {
      header.dataset.menuStyle = 'drawer';
    }
  }

  function init() {
    initInlineSearchIds();

    const header = document.querySelector('#header-component');
    if (!header) return;

    enforce(header);

    new MutationObserver(() => enforce(header)).observe(header, {
      attributes: true,
      attributeFilter: ['data-menu-style'],
    });

    window.addEventListener('resize', () => enforce(header));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
